import { evaluarReglasActivacion, estadoMostrado, puedeActivar } from './inscripcionRules'
import { isValidCurp } from './curp'
import { consentimientoValido } from './consent'
import { normalizeSportValue } from '../constants/sports'

export const buildFilasInscripcion = ({
  jugadores = [],
  inscripcionesByJugador = {},
  consentByJugador = {},
  exigirConsentimiento = false,
  deporteId,
} = {}) => {
  const deporte = normalizeSportValue(deporteId)
  return jugadores.map((j) => {
    const insc = inscripcionesByJugador[j.id] || null
    const estatusGuardado = insc ? insc.estatus : null

    const curpValida = isValidCurp(j.curp)
    const trataDatos = consentimientoValido(consentByJugador[j.id], {
      fechaNacimiento: j.fecha_nacimiento,
      bajoTutela: j.bajo_tutela_legal,
    })
    const { reglas, todasCumplen } = evaluarReglasActivacion({
      curpValida, trataDatos, exigirConsentimiento,
    })

    // Solo membresias VIVAS: sin el filtro salian grupos que el jugador ya dejo,
    // y la columna "Grupo(s)" y el filtro "Relevantes" mentian.
    const gruposDelDeporte = (j.jugadores_grupos || [])
      .filter((jg) => jg.activo && !jg.deleted)
      .map((jg) => jg.grupos)
      .filter((g) => g && normalizeSportValue(g.deporte) === deporte)
      .map((g) => ({ id: g.id, nombre: g.nombre_del_grupo }))

    return {
      jugadorId: j.id,
      nombre: j.nombre_completo,
      numero: j.numero,
      gruposDelDeporte,
      inscrito: !!insc,
      inscripcionId: insc ? (insc.id ?? null) : null,
      estatusGuardado,
      reglas,
      todasCumplen,
      estadoMostrado: insc ? estadoMostrado({ estatusGuardado, todasCumplen }) : 'no_inscrito',
      puedeActivar: insc ? puedeActivar({ estatusGuardado, todasCumplen }) : false,
    }
  })
}
